<!-- chat-input-ce.component.html -->
<div class="chatbar">
  <div
    #input
    class="input"
    contenteditable="true"
    [attr.aria-label]="placeholder"
    [attr.data-placeholder]="placeholder"
    [attr.spellcheck]="spellcheck"
    [attr.autocapitalize]="autocapitalize"
    [attr.autocomplete]="autocomplete"
    [attr.inputmode]="inputmode"
    (input)="onInput()"
    (keydown)="onKeydown($event)"
    (paste)="onPaste($event)"
  >
  </div>

  <button
    mat-icon-button
    matSuffix
    type="button"
    class="button"
    (click)="send()"
    [disabled]="disabled || !canSend()"
    aria-label="Send message"
    title="Send"
  >
    <mat-icon>send</mat-icon>
  </button>
</div>
